// Authentication routes - common for all projects
import React from 'react'
import { Route, Navigate } from 'react-router-dom'
import Activation from '../../containers/Authentication/screens/Activation/Activation'
import ForgotPassword from '../../containers/Authentication/screens/ForgotPassword/ForgotPassword'
import LogIn from '../../containers/Authentication/screens/LogIn'
import GoogleOAuthCallback from '../../containers/Authentication/screens/LogIn/GoogleOAuthCallback'
import LogInAdmin from '../../containers/Authentication/screens/LogInAdmin/LogInAdmin'
import SignUp from '../../containers/Authentication/screens/SignUp/SignUp'
import CodeConfirmation from '../../containers/CodeConfirmation'

/**
 * Get authentication routes for not logged in users
 * @param {boolean} isLoggingIn - Is user currently logging in
 * @returns {JSX.Element} React fragment with routes
 */
export const getAuthRoutes = (isLoggingIn = false) => {
	return (
		<>
			<Route
				path='/'
				element={<Navigate to={`/login${window.location.search || ''}`} replace />}
			/>
			<Route
				path='/social/complete/google-oauth2/*'
				element={<GoogleOAuthCallback />}
			/>
			<Route
				path='/login'
				element={<LogIn />}
			/>
			<Route
				path='/signup'
				element={<SignUp />}
			/>
			<Route
				path='/manager'
				element={<LogInAdmin />}
			/>
			<Route
				path='/forgot'
				element={<ForgotPassword />}
			/>
			<Route
				path='/forgot/:code'
				element={<ForgotPassword />}
			/>
			<Route
				path='/activation/:code'
				element={<Activation />}
			/>
			<Route
				path='/confirm-2fa'
				element={<CodeConfirmation />}
			/>
			{isLoggingIn && (
				<Route
					path='*'
					element={<Navigate to='/login' replace />}
				/>
			)}
		</>
	)
}
